<template>
  <div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
      :key="keyChange"
    >
      <a-form-model-item label="Name" prop="name">
        <a-input v-model="form.name" placeholder="Enter text..." />
      </a-form-model-item>
      <a-form-model-item label="Number Order">
        <a-input-number
          :formatter="
            (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          :min="0"
          v-model="form.numberOrder"
          placeholder="Enter number..."
          style="width: 100%;"
        />
      </a-form-model-item>

      <a-form-model-item label="Description">
        <a-input v-model="form.description" placeholder="Enter text..." />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";
// components
const rules = {
  name: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
};
const defaultForm = {};
export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { ...defaultForm },
      loading: false,
      keyChange: 0,
    };
  },
  methods: {
    setFormItem(nameForm, value) {
      this.$set(this.form, nameForm, value);
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        console.log("Valid:", valid);
        console.log("Rules:", this.rules);

        if (valid) {
          this.onCreatedAppInPlatformGroup();
        } else {
          return false;
        }
      });
    },

    onCreatedAppInPlatformGroup() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createAppInPlatformGroup,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Create success!",
          });
          this.loading = false;
          this.form = { ...defaultForm };
          if (data?.createAppInPlatformGroup?.id) {
            this.refreshAfterCreated(data.createAppInPlatformGroup);
          }
          this.keyChange += 1;
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Error",
            description: "Create error!",
          });
          console.error("Thêm app in platform group không thành công", err);
        });
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
